// extracted by mini-css-extract-plugin
var _1 = "NewsboardMessageText-modulemessage__dExrR";
var _2 = "NewsboardMessageText-modulereadMoreButton__F0b3_";
var _3 = "NewsboardMessageText-moduleunread__i95Yz";
export { _1 as "message", _2 as "readMoreButton", _3 as "unread" }
